#import "~/graphql/fragments/Comment.graphql"

query Comments(
    $videoId: ID!
    $refreshAt: String
) {
    comments(
        video_id: $videoId
        refreshed_at: $refreshAt
    ) {
        ...Comment

        childComments {
            ...Comment
        }
    }
}